var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location-distance"},[_c('div',{staticClass:"location-distance__title"},[_vm._v(" "+_vm._s(_vm.$t('location.distance.title'))+" ")]),_c('vue-slider',{staticClass:"location-distance__slider",attrs:{"value":_vm.currentDistance,"tooltip":"focus","min":_vm.distanceArray[0],"max":_vm.distanceArray[1],"clickable":false,"dotSize":24,"interval":1,"enable-cross":false,"tooltip-formatter":("{value} " + _vm.distanceUnit),"tooltipPlacement":"bottom","rail-style":{
      backgroundColor: '#ddd',
      height: '6px',
    },"dot-style":{
      backgroundColor: '#54cad9',
      border: '2px solid #fff',
      boxShadow: 'none',
    },"process-style":{ backgroundColor: '#54cad9' },"tooltip-style":{
      backgroundColor: '#54cad9',
      borderColor: '#54cad9',
      fontSize: '0.75rem',
      fontWeight: 'bold',
      padding: '4px 8px',
    },"marks":_vm.marksDistance},on:{"dragging":_vm.update,"drag-end":_vm.refresh}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }